import { createContext } from "react";

import { GlobalContextType } from "@/contexts/Global/types";

const GlobalContext = createContext<GlobalContextType>({
  isAlertShown: false,
  setIsAlertShown: () => {},
  currentSessionData: null,
  setCurrentSessionData: () => {},
  alertStatus: null,
  setAlertStatus: () => {},
  isExpert: false,
  setIsExpert: () => {},
  isBadgeModalOpen: false,
  openBadgeModal: () => {},
  closeBadgeModal: () => {},
});

export default GlobalContext;
